"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 14';

var InProgress = function InProgress() {
  return _react["default"].createElement("path", {
    d: "M10.341 7.963l-3.198.712a.652.652 0 01-.799-.64V2.187a.655.655 0 111.312 0v5.03l2.4-.534a.657.657 0 01.285 1.28M7.001 0a7 7 0 100 14A7 7 0 007 0"
  });
};

var _default = (0, _createSvgIcon["default"])(InProgress, {
  viewBox: viewBox
});

exports["default"] = _default;